module.exports = __webpack_public_path__ + "media/images/supporters_lp/bg1-ef3c1fed70003f320f4745bba497cb80.jpg";